import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {NavigationService} from 'src/app/services/navigation.service';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import Order from 'src/smoothr-web-app-core/models/Order';
import {MenuPage} from 'src/app/pages/menu/menu.page';
import {MapPage} from 'src/app/pages/map/map.page';
import {Router} from '@angular/router';

@Component({
	selector: 'app-toolbar-logo',
	templateUrl: './toolbar-logo.component.html',
	styleUrls: ['./toolbar-logo.component.scss']
})
export class ToolbarLogoComponent extends RepositoryDirective implements OnInit {
	@Input() menuButton: boolean = true;
	@Input() venueSelect: boolean = false;
	@Input() crossBtn: boolean = false;
	venue: Venue;
	order: Order;
	@Output() navigateMap = new EventEmitter<void>();
	@Output() backClick = new EventEmitter<void>();
	constructor(
		public repository: RepositoryService,
		public navigationService: NavigationService,
		private router: Router
	) {
		super(repository);
	}
	ngOnInit(): void {
		super.ngOnInit();
	}

	async goBack() {
		if (this.repository._order === null) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
		this.backClick.emit();
	}
	async editVenue() {
		this.navigateMap.emit();
	}
	close() {
		this.backClick.emit();
	}
}
